module.exports = __webpack_public_path__ + "circle.b14d6290d2bf25c8cd0c.png";


//////////////////
// WEBPACK FOOTER
// L:/Vodafone/Happy Check/dev/vodhappycheck/src/assets/images/circle.png
// module id = ../../../../../src/assets/images/circle.png
// module chunks = styles